import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { SponsorshipTierListItem } from "../../data/sponsorInfo";

interface DeleteSponsorTierModalProps {
    open: boolean;
    tier: SponsorshipTierListItem | null;
    isDeleting: boolean;
    onClose: () => void;
    onConfirmDelete: () => void;
}

const DeleteSponsorshipTierModal: React.FC<DeleteSponsorTierModalProps> = ({
    open,
    tier,
    isDeleting,
    onClose,
    onConfirmDelete
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                Are you sure you want to delete <strong>{tier?.Name}</strong> tier?
            </DialogTitle>

            <DialogContent>
                <Typography>
                    This action cannot be undone. Once deleted, the sponsorship tier will be permanently removed.
                </Typography>
            </DialogContent>

            <DialogActions>
                {/* Cancel Button */}
                <Button onClick={onClose} color="inherit" sx={{ textTransform: "none" }}>
                    Cancel
                </Button>

                {/* Delete Button */}
                <Button
                    onClick={onConfirmDelete}
                    color="error"
                    sx={{ textTransform: "none" }}
                    disabled={isDeleting}
                >
                    {isDeleting ? "Deleting..." : "Delete"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteSponsorshipTierModal;